import { render, staticRenderFns } from "./commentinfo.vue?vue&type=template&id=ea24fd44&scoped=true"
import script from "./commentinfo.vue?vue&type=script&lang=js"
export * from "./commentinfo.vue?vue&type=script&lang=js"
import style0 from "./commentinfo.vue?vue&type=style&index=0&id=ea24fd44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea24fd44",
  null
  
)

export default component.exports